// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-links {
  display: flex;
  gap: 14px;
}

/* White circle with a coral-deep icon (6.05): reads on the light page and
   on the dark footer alike. */
.social-link,
.social-link:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--surface-raised);
  color: var(--text-accent);
  box-shadow: var(--shadow-soft);
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.social-link:hover {
  transform: translateY(-2px);
  background-color: var(--interactive-default);
  color: var(--interactive-label);
}

@media (prefers-reduced-motion: reduce) {
  .social-link,
  .social-link:hover {
    transition: none;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SocialLinks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;8BAC8B;AAC9B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".social-links {\n  display: flex;\n  gap: 14px;\n}\n\n/* White circle with a coral-deep icon (6.05): reads on the light page and\n   on the dark footer alike. */\n.social-link,\n.social-link:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: var(--surface-raised);\n  color: var(--text-accent);\n  box-shadow: var(--shadow-soft);\n  transition: transform 0.15s ease, background-color 0.15s ease;\n}\n\n.social-link:hover {\n  transform: translateY(-2px);\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .social-link,\n  .social-link:hover {\n    transition: none;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
